import{z as e}from"zod";const t=e.string().min(1).max(255),n=e.string().min(1).max(255),r=e.string().max(255);export{n as appDisplayNameSchema,r as appDisplayNameUpdateSchema,t as appNameSchema};
//# sourceMappingURL=app.schema.mjs.map